import { render, staticRenderFns } from "./ProgramCourses.vue?vue&type=template&id=05bbbb36&scoped=true"
import script from "./ProgramCourses.vue?vue&type=script&lang=js"
export * from "./ProgramCourses.vue?vue&type=script&lang=js"
import style0 from "./ProgramCourses.vue?vue&type=style&index=0&id=05bbbb36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05bbbb36",
  null
  
)

export default component.exports